import Vue from 'vue'
import axios, { AxiosInstance } from 'axios'

const crossOriginUriCollection = new Array<string>()
crossOriginUriCollection.push('*')

axios.defaults.headers.common[
  'Access-Control-Allow-Origin'
] = crossOriginUriCollection.join(',')
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common.Pragma = 'no-cache'
axios.defaults.headers.get.Expires = -1
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosInstance
  }
}

const instance = axios.create()

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    let fixedtoken = token.replace('"', '')
    fixedtoken = fixedtoken.replace('"', '')
    if (!config.headers) {
      config.headers = {}
    }
    config.headers.Authorization = `Bearer ${fixedtoken}`
  }

  return config
})

Vue.prototype.$http = instance

export default instance
